import { useState, useEffect } from 'react';
import { memedConfigApi, type MemedConfig } from '@/api/http-client';

export interface UseMemedConfigResult {
  data: MemedConfig | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useMemedConfig(): UseMemedConfigResult {
  const [data, setData] = useState<MemedConfig | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [refetchIndex, setRefetchIndex] = useState(0);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    memedConfigApi
      .getConfig()
      .then((config) => {
        if (!active) return;
        setData(config);
      })
      .catch((err) => {
        if (!active) return;
        setError(err instanceof Error ? err.message : 'Erro ao carregar configurações da MeMed');
      })
      .finally(() => {
        if (active) {
          setIsLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [refetchIndex]);

  const refetch = () => {
    setRefetchIndex((index) => index + 1);
  };

  return { data, isLoading, error, refetch };
}
